import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'

/* Enscapsulates the event logic of handling selection of columns for legacy report
 * displays that use checkboxes.
 */
var SelectColumnsForm = Backbone.View.extend({

	events: {
		'change input[name=columns]' : 'toggleColumns',
		'change .showAbbreviatedValues' : 'toggleAbbreviatedValues'
	},

	initialize: function(options) {
		if (!this.model.has('columns')) {
			this.model.set('columns', {columns: []})
		}
		this.columns = this.model.get('columns').columns
	},

	render: function() {
		var selected = _.keyBy(this.columns)
		this.$('input[name=columns]').each(function() {
			var cb = $(this)
			cb.prop('checked', !_.isUndefined(selected[cb.val()]))
		})
		this.$('input[name=showAbbreviatedValues]').prop('checked', !!this.model.get('showAbbreviatedValues'))
	},

	toggleAbbreviatedValues(e) {
		this.model.set('showAbbreviatedValues',$(e.target).prop('checked'))
	},

	toggleColumns: function(e) {
		var cb = this.$(e.target)
		var c = this.model.get('columns')
		if (cb.is(':checked')) {
			c.columns.push(cb.val())
		} else {
			_.pull(c.columns, cb.val())
		}
		this.model.trigger('change')
	}

})

export default SelectColumnsForm
SelectColumnsForm.__filename__ = 'reports/wizard/common/select-columns-form.js'
